module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f074e5_logo_200x200.94c510c0.png";